import React from 'react';

class DefaultError extends React.PureComponent {
    render() {
        return (
            <div id='mother'>
                <div className={`invalid-license ${this.props.isMobile ? 'mobile' : ''}`}>
                    <div className='wrap'>
                        <img alt='cocopacket-logo' src='/less/img/cocopacket-logo_inverse.svg' />
                        <div className='box'>
                            We are sorry, but it seems like an unexpected error occured.
                            <br />
                            <br />
                            If you have experienced this error, multiple times please contact our support team
                            <br />
                            <br />
                            <a rel='noopener' href='mailto:support@cocopacket.com' className='link'>
                                support@cocopacket.com
                            </a>
                            <br />
                            <div className='controls'>
                                <a href='/'>Go Home</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DefaultError;
